<div class="card" (click)="cardClicked()">
    <div class="card-content">
        <div class="card-icon">
            <mat-icon svgIcon="services"></mat-icon>
        </div>
        <div class="card-body">
            <h6>
                <span class="card-title text-capitalize font-weight-bold dark-grey">{{service.Name}}</span>
                <h6 class="card-subtitle mb-2 text-muted text-uppercase">Service {{service.Barcode}}</h6>
                <p class="card-text text-muted text-capitalize" *ngIf="service.ServiceCategory">
                    {{service.ServiceCategory}}
                </p>
            </h6>
        </div>
    </div>
</div>